import { useSelectFormById } from "@/features/forms/api/selectFormById";
import FormPage from "@/features/pages/components/FormPage";
import useFormPage from "@/features/pages/hooks/useFormPage";
import { createFileRoute } from "@tanstack/react-router";
import { useNavigate } from "@tanstack/react-router";

const Page = () => {
	const { pageIndex, formId, entryId } = Route.useParams();
	const navigate = useNavigate();
	const { data: form } = useSelectFormById(formId);

	const currentPage = form?.pages?.find(
		(p) => p?.page_index === Number(pageIndex),
	);

	const {
		form: reactHookForm,
		onSubmit,
		prevPage,
		nextPage,
	} = useFormPage({
		pageCount: form?.pages?.length ?? 1,
		inputs: currentPage?.inputs ?? [],
		nextEntry: null,
		nextPageFn: (newPageIndex) => {
			navigate({
				to: Route.to,
				params: { formId, entryId, pageIndex: String(newPageIndex) },
			});
		},
		prevPageFn: (newPageIndex) => {
			navigate({
				to: Route.to,
				params: { formId, entryId, pageIndex: String(newPageIndex) },
			});
		},
		successFn: () => {
			navigate({
				to: Route.to,
				params: { formId, entryId, pageIndex: String(Number(pageIndex) + 1) },
			});
		},
		completeFn: () => {
			navigate({
				to: "/public/form/$formId/complete",
				params: { formId },
			});
		},
	});

	if (!form || !currentPage) return null;

	return (
		<section className="md-width">
			<FormPage
				pageIndex={Number(pageIndex)}
				form={form}
				route={Route}
				reactHookForm={reactHookForm}
				onSubmit={onSubmit}
				prevPage={prevPage}
				nextPage={nextPage}
			/>
		</section>
	);
};

export const Route = createFileRoute(
	"/public/form/$formId/entry/$entryId/page/$pageIndex",
)({
	component: Page,
});
